import { DATABASE_TIME_ZONE } from '../constants/general'
import * as dayjs from 'dayjs'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

// Helper function to ensure the SQL date is in a standard UTC format
const normalizeSqlDate = sqlDate => {
    return sqlDate.at(-1) !== 'Z' ? `${sqlDate}Z` : sqlDate
}

const getUserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

export const sqlToJsDate = sqlDate => {
    try {
        const normalizedDate = normalizeSqlDate(sqlDate)
        const dateWithoutTimeZone = new Date(Date.parse(normalizedDate))
        const userTimeZone = getUserTimeZone()
        return dateWithoutTimeZone.toLocaleString(DATABASE_TIME_ZONE, { timeZone: userTimeZone })
    } catch (e) {
        console.error(e)
        return 'Invalid Date'
    }
}

export const sqlToTimeFromNow = sqlDate => {
    try {
        const normalizedDate = normalizeSqlDate(sqlDate)
        const userTimeZone = getUserTimeZone()
        return dayjs(normalizedDate).tz(userTimeZone).fromNow()
    } catch (e) {
        console.error(e)
        return 'Invalid Date'
    }
}

export const dayjsToCurrentTimeZone = dayjs => {
    const userTimeZone = getUserTimeZone()
    return dayjs.tz(userTimeZone)
}

export const buildUnixRangeFromDatetime = (datetime, rangeInHours = 1) => {
    const date = new Date(datetime)
    const unixDate = date.getTime()
    const unixRange = rangeInHours * 60 * 60 * 1000
    return [unixDate - unixRange, unixDate + unixRange]
}
